import { ContainerModule, interfaces } from 'inversify';
import { BatchAnnotationApiService, IBatchAnnotationApiService } from './services/BatchAnnotationApi.service';
import { FreeAccessAnnotationApiService, IFreeAccessAnnotationApiService } from './services/FreeAccessAnnotationApi.service';

export const editorModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IBatchAnnotationApiService.$).to(BatchAnnotationApiService).inSingletonScope();
  bind(IFreeAccessAnnotationApiService.$).to(FreeAccessAnnotationApiService).inSingletonScope();
});
